import { render, staticRenderFns } from "./AppDescriptionSubHeader.vue?vue&type=template&id=06dff68e&scoped=true&"
import script from "./AppDescriptionSubHeader.vue?vue&type=script&lang=js&"
export * from "./AppDescriptionSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppDescriptionSubHeader.vue?vue&type=style&index=0&id=06dff68e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dff68e",
  null
  
)

export default component.exports